<template>
  <div v-if="isLoggedIn"
    class="Lifelayer_main_parent_container aside element-to-hide"
    id="assidemenu"
  >
    <div class="lifelayer-close-box">
      <img
        src="../assets/imagesFolder/close-svgrepo-com.svg"
        class="lifelayer-close-icon"
        alt="Close Icon"
      />
    </div>
    <div class="Lifelayer-main grid-container">
      <div
        class="lifelayer-sidebar-left column column-1"
        ref="column1"
        @mouseenter="enableScroll('column1')"
        @mouseleave="resetScroll"
        @scroll="handleScroll('column1')"
      >
        <img
          class="lifelayer-menu-icon"
          src="../assets/svgFolder/menu-svgrepo-com (1).svg"
          height="30px"
        />
        <div class="lifelayer-sidebar" id="myElement">
          <div class="radio1" style="z-index: 9999">
            <router-link v-if="currentRolePath" :to="currentRolePath">
              <div class="profile_picture_container" v-if="userData">
                <img
                  class="video1"
                  id="sidebar-image"
                  :src="userData.imageUrl || fallbackImage"
                  alt="Avatar"
                />
              </div>
            </router-link>
          </div>

          <div
            class="lifelayer-icon-container"
            :class="{ active: activeContainer === index }"
            @click="setActiveContainer(index)"
          >
            <div class="lifelayer-sidebar-icon" data-tooltip="Dashboard">
              <div class="sidebar-icon-container">
                <img
                  class="sidebar-icon"
                  src="../assets/dashboard/icons/dashboard-3-svgrepo-com.svg"
                  alt="Dashboard"
                />
              </div>
            </div>
            <div class="lifelayer-tooltip">
              <div class="lifelayer-tooltip-text">Dashboard</div>
              <div
                class="lifelayer-sidebar-dropdown"
                :style="{
                  position:
                    index >= sidebarItems.length - 2 ? 'absolute' : 'static',
                }"
              >
                <div
                  class="lifelayer-dropdown-item"
                  to="/patient_dashboard"
                  :class="{ active: activeDropdownItem === Dashbaord }"
                >
                  <router-link
                    v-if="this.$store.getters.hasuserdetails?.group_id == 1"
                    to="/admin_dashboard"
                  >
                    <a
                      href="javascript:void(0)"
                      class="languageChange dasboard_sidebar"
                      id="admin_dashboard"
                      >Dashboard</a
                    >
                  </router-link>
                  <router-link
                    v-else-if="
                      this.$store.getters.hasuserdetails?.group_id == 4
                    "
                    to="/patient_dashboard"
                  >
                    <a
                      href="javascript:void(0)"
                      class="languageChange dasboard_sidebar"
                      id="patient_dashboard"
                      >Dashboard</a
                    >
                  </router-link>
                  <router-link
                    v-else-if="
                      this.$store.getters.hasuserdetails?.group_id == 3
                    "
                    to="/vendor_dashboard"
                  >
                    <a
                      href="javascript:void(0)"
                      class="languageChange dasboard_sidebar"
                      id="vendor_dashboard"
                      >Dashboard</a
                    >
                  </router-link>
                  <router-link
                    v-else-if="
                      this.$store.getters.hasuserdetails?.group_id == 2
                    "
                    to="/doctor_dashboard"
                  >
                    <a
                      href="javascript:void(0)"
                      class="languageChange dasboard_sidebar"
                      id="doctor_dashboard"
                      >Dashboard</a
                    >
                  </router-link>
                  <router-link
                    v-else-if="
                      this.$store.getters.hasuserdetails?.group_id == 5
                    "
                    to="/student_dashboard"
                  >
                    <a
                      href="javascript:void(0)"
                      class="languageChange dasboard_sidebar"
                      id="doctor_dashboard"
                      >Dashboard</a
                    >
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- Dynamic sidebar start -->
          <div
            v-for="(item, index) in sidebarItems"
            :key="item.tooltip"
            class="lifelayer-icon-container"
            :class="{ active: activeContainer === index }"
            @click="setActiveContainer(index)"
          >
            <div
              v-permission="`${item.moduleName}:access`"
              class="lifelayer-sidebar-icon"
              :data-tooltip="item.tooltip"     
            >
              <div class="sidebar-icon-container">
                <img
                  class="sidebar-icon"
                  :src="item.iconSrc"
                  :alt="item.tooltip"
                />
              </div>
            </div>

            <div class="lifelayer-tooltip">
              <div class="lifelayer-tooltip-text">
                {{ item.tooltipText }}
              </div>

              <div
                class="lifelayer-sidebar-dropdown"
                :style="{
                  position:
                    index >= sidebarItems.length - 2 ? 'absolute' : 'static',
                }"
              >
                <div
                  v-for="option in item.dropdownOptions"
                  :key="option.subMenu"
                  class="lifelayer-dropdown-item"
                  @click="navigateTo(option.url)"
                  :class="{
                    active: activeDropdownItem === option.subMenu,
                  }"
                >
                  {{ option.subMenu }}
                </div>
              </div>
            </div>
          </div>
          <!-- Dynameic sidebar end  -->
        </div>
      </div>

      <div
        class="column column-2"
        ref="column2"
        @mouseenter="enableScroll('column2')"
        @mouseleave="resetScroll"
      >
        <div class="page" v-for="(page, index) in pages" :key="index">
          <img :src="page" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userData: null,
      mysidebar: "",
      sidebarItems: [],
      items: {
        image: "",
        user_id: null,
      },
      activeContainer: null,
      activeDropdownItem: null,
      tooltipVisible: false,
      fetchdata: null,
      modifiedSidebar: [],
      fallbackImage: require("../assets/profile/img/userProfile.jpg"),
    };
  },

  computed: {
    role() {
      return this.$store.getters.hasuserdetails?.role || "";
    },
    isLoggedIn() {
    return !!(
      this.$store.getters.hasuserdetails ||
      JSON.parse(sessionStorage.getItem("user") || "null")
    );
  },

  currentRolePath() {
  const details =
    this.$store.getters.hasuserdetails ||
    JSON.parse(sessionStorage.getItem("user") || "null");

  if (!details) return "/";

  if (details.candidateEmail && details.role === "Doctor") {
    return "/company-doctor";
  }

  if (
    (details.candidateEmail && details.role === "Admin") ||
    details.role === "Super Admin"
  ) {
    return "/admin";
  }
     if (details.candidateEmail && details.role === "director") {
        return `/business/${details.company_code}`;
      }

  return "/employee";
},
  },
  methods: {
    formatText(text) {
      return text
        .replace(/_/g, " ")
        .replace(/\b\w/g, (firstChar) => firstChar.toUpperCase());
    },
    convertToHttpsUrl(path) {
      console.log(path, "path");
      if (!path) return "";
      const cleanedPath = path.replace(/\\/g, "/").replace(/ /g, "%20");
      const withoutPrefix = cleanedPath.replace(/^\/\//, "");
      console.log(withoutPrefix, "withoutPrefix");
      return `https://${withoutPrefix}`;
    },
   sidebar_menu() {
  const user =
    this.$store.getters.hasuserdetails ||
    JSON.parse(sessionStorage.getItem("user") || "null");

  if (!user) return;

  const companycode = user.company_code;
  const role = user.role;

  let api;

  if (role === "Admin" || role === "director") {
    api =
      process.env.VUE_APP_BASE_URL +
      `companyPermissions/get_modules_permission/${companycode}`;
  } else {
    api =
      process.env.VUE_APP_BASE_URL +
      `employeePermissions/employees_module_permissions/${companycode}/${role}`;
  }

  axios
    .get(api)
    .then((response) => {
      const permissionData = response.data.data || [];

      this.sidebarItems = permissionData.map((item) => ({
        moduleName: item.moduleName,
        tooltip: this.formatText(item.moduleName),
        tooltipText: this.formatText(item.moduleName),
        iconSrc:
          item.module_icon ||
          "https://cdn-icons-png.flaticon.com/512/847/847969.png",
        dropdownOptions: (item.pages || []).map((page) => ({
          pageName: page.object_view_name,
          subMenu: this.formatText(page.object_view_name),
          url: page.object_view_name,
        })),
      }));
    })
    .catch(console.error);
},
    openHTMLProject() {
      const url = "http://192.168.1.42:5500/src/Dviewer/html/start.html";
      window.open(url, "_blank");
    },
   fetchProductDetails() {
  const user =
    this.$store.getters.hasuserdetails ||
    JSON.parse(sessionStorage.getItem("user") || "null");

  if (!user) return;

  axios.post(
    `${process.env.VUE_APP_BASE_URL}profile-customization/get_doctorDatabyid`,
    {
      id: user._id,
    }
  )
  .then((response) => {
    this.fetchdata = response.data.Data;
  })
  .catch((error) => {
    console.error(error);
  });
},

    // fetch userImage
    async fetchUserImage() {
      try {
       const user =
  this.$store.getters.hasuserdetails ||
  JSON.parse(sessionStorage.getItem("user") || "null");

if (!user) return;

const user_id = user.userId;

        if (!user_id) {
          return;
        }
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}auth/getimage/${user_id}`, 
   
          {
             params:{
              companyCode: user.company_code
            },
             withCredentials: true
             },
        );
        this.userData = response.data;
        console.log("Fetch Image Successfully", this.userData);
      } catch (err) {
        console.log("Error to fetch image", err);
      }
    },
    setActiveContainer(index) {
      this.activeContainer = index;
    },
    setActiveDropdownItem(subMenu) {
      this.activeDropdownItem = subMenu;
    },
    navigateTo(url) {
      this.$router.push({ path: `/${url}` });
    },
    enableScroll(column) {
      if (column === "column1") {
        this.$refs.column1.style.overflowY = "auto";
        this.$refs.column2.style.overflowY = "hidden";
      } else if (column === "column2") {
        this.$refs.column2.style.overflowY = "auto";
        this.$refs.column1.style.overflowY = "hidden";
      }
    },
    resetScroll() {
      this.$refs.column1.style.overflowY = "auto";
      this.$refs.column2.style.overflowY = "auto";
    },
    showTooltip() {
      // console.log("mouseenter");

      this.tooltipVisible = true;
    },
    hideTooltip() {
      // console.log("mouseleave");

      this.tooltipVisible = false;
    },
    handleScroll() {
      this.tooltipVisible = false;
    },
  },

created() {
  const user =
    this.$store.getters.hasuserdetails ||
    JSON.parse(sessionStorage.getItem("user") || "null");

  if (!user) return;

  this.sidebar_menu();
  this.fetchUserImage();
  
},

mounted() {
  this.fetchProductDetails();

  setTimeout(() => {
    const icons = this.$el.querySelectorAll(".lifelayer-icon-container");
    icons.forEach((container, index) => {
      const icon = container.querySelector(".lifelayer-sidebar-icon");
      const tooltip = container.querySelector(".lifelayer-tooltip");
      const dropdown = container.querySelector(".lifelayer-sidebar-dropdown");

      if (!icon || !tooltip || !dropdown) {
        return;
      }

      icon.addEventListener("mouseenter", () => {
        const rect = icon.getBoundingClientRect();
        tooltip.style.top = `${rect.top}px`;
        tooltip.style.display = "block";
      });

      icon.addEventListener("mouseleave", () => {
        setTimeout(() => {
          if (!tooltip.matches(":hover") && !dropdown.matches(":hover")) {
            tooltip.style.display = "none";
            dropdown.style.display = "none";
          }
        }, 10);
      });

      tooltip.addEventListener("mouseenter", () => {
        dropdown.style.display = "block";
      });

      tooltip.addEventListener("mouseleave", () => {
        dropdown.style.display = "none";
        tooltip.style.display = "none";
      });

      // Menu hover
      this.$nextTick(() => {
        const menuItems = document.querySelectorAll(".menu-item");

        if (menuItems.length) {
          menuItems.forEach((menuItem) => {
            menuItem.addEventListener("mouseover", () => {
              menuItems.forEach((item) => item.classList.remove("active"));
              menuItem.classList.add("active");
            });
          });
        }
      });

      // Sidebar scroll
      const myElement = document.getElementById("myElement");

      if (myElement) {
        myElement.addEventListener("scroll", () => {
          const dropdown =
            container.querySelector(".lifelayer-sidebar-dropdown");
          const tooltip =
            container.querySelector(".lifelayer-tooltip");

          if (dropdown) dropdown.style.display = "none";
          if (tooltip) tooltip.style.display = "none";
        });
      }

      dropdown.addEventListener("mouseleave", () => {
        if (tooltip) tooltip.style.display = "none";
        dropdown.style.display = "none";
      });

      // Last 2 dropdowns
      if (index >= icons.length - 2) {
        dropdown.style.position = "absolute";
        dropdown.style.top = "100%";
        dropdown.style.bottom = "auto";
      }
    });

    // Menu Icon
    const menuIcons = this.$el.querySelectorAll(".lifelayer-menu-icon");

    menuIcons.forEach((icon) => {
      icon.addEventListener("click", () => {
        const sidebar = this.$el.querySelector(".lifelayer-sidebar");

        if (!sidebar) return;

        sidebar.style.display = "block";

        const closeIcons =
          this.$el.querySelectorAll(".lifelayer-close-icon");

        closeIcons.forEach((closeIcon) => {
          if (!closeIcon) return;

          closeIcon.style.display = "inline-block";
          closeIcon.style.position = "absolute";
          closeIcon.style.zIndex = "9999";

          closeIcon.addEventListener("click", () => {
            sidebar.style.display = "none";
            closeIcon.style.display = "none";
          });
        });
      });
    });

    // Active dropdown
    const dropdownItems = this.$el.querySelectorAll(
      ".lifelayer-dropdown-item"
    );

    dropdownItems.forEach((item) => {
      item.addEventListener("click", () => {
        dropdownItems.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");
      });
    });
  }, 2000);
},
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.lifelayer-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 50px;
  height: 100%;
  color: black;
  overflow-y: auto;
  /*z-index: 9999999999999;*/
  z-index: 99;
  background-color: white;
}

.lifelayer-sidebar::-webkit-scrollbar {
  display: none;
}

.lifelayer-menu-icon {
  position: absolute;
  font-size: 25px;
  margin-left: 10px;
  display: none;
}

.lifelayer-close-icon {
  font-size: 25px;
  display: none;
  margin-left: -40px;
}

.lifelayer-close-box {
  float: right;
}

.lifelayer-sidebar-icon {
  padding: 2px;
  cursor: pointer;
  text-align: center;
}

.lifelayer-tooltip {
  position: fixed;
  background: #6b0a23;
  color: white;
  padding: 0px 0px 0px 0px;
  display: none;
  width: 200px;
  font-size: 10px;
  margin-left: 50px !important;
}

.lifelayer-tooltip-text {
  padding: 10px 0px 9.5px 0px;
  font-weight: 600;
  font-size: 12px;
  height: 35px;
}

.lifelayer-icon-container {
  position: relative;
  z-index: 99999999;
}

.lifelayer-icon-container:hover {
  background-color: #6b0a23 !important;
  color: white !important;
}

.lifelayer-sidebar-dropdown {
  display: none;
  position: absolute;
  background: #cdf4fb;
  color: black;
  font-weight: 400;
  margin-left: 0px !important;
  padding: 5px 0px 0px 0px;
  left: 45px;
  width: 200px;
  height: 180px !important;
  transition: 1s ease-in-out;
  top: 35px; /* Added to ensure dropdown appears below tooltip */
}

.lifelayer-sidebar-dropdown i {
  position: absolute;
  color: #a5a0a0;
  right: 40px;
  bottom: 5px;
}

.lifelayer-dropdown-item {
  padding: 13px;
  font-size: 12px;
  z-index: 999;
}

.lifelayer-dropdown-item:hover {
  color: white;
}

.lifelayer-icon-container:nth-child(1) {
  margin-top: 1000px;
}

.lifelayer-icon-container {
  position: relative;
  font-size: 24px;
  top: 60px;
  margin: 0px 0px 10px 0px;
  z-index: -999 !important;
}

.lifelayer-icon-container.active {
  background-color: #6b0a23 !important;
  color: white;
  border-radius: 0 !important;
}

.lifelayer-icon-container.active .sidebar-icon {
  filter: invert(100%);
  border-radius: 0px !important;
}

/* akash changes start here */
.lifelayer-icon-container .lifelayer-sidebar-icon {
  padding: 2.5px 10px;
  height: 35px;
}
/* akash changes end here */

.lifelayer-dropdown-item:hover {
  cursor: pointer;
  color: black;
  background-color: rgb(165, 214, 234);
  transition: 0.3s;
}

.lifelayer-dropdown-item.active {
  background-color: white;
  color: black;
  border-radius: 0px !important;
}

.sidebar-icon.active {
  color: white;
}

/* akash changes start here */
.sidebar-icon-container {
  width: 20px;
  margin: auto;
}
/* akash changes end here */

.lifelayer-sidebar-icon:hover .sidebar-icon {
  filter: invert(100%);
}

.sidebar-icon-container .sidebar-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sidebar-icon {
  fill: white;
}

/* FIXED: Updated this CSS rule to position dropdown below for last 2 items */
.lifelayer-icon-container:nth-last-child(-n + 2) .lifelayer-sidebar-dropdown {
  top: 35px; /* Position below the tooltip */
  bottom: auto;
  left: 0px;
}

.lifelayer-sidebar-dropdown {
  height: 200px;
  overflow-y: scroll;
  scrollbar-width: thin;
}

.lifelayer-profile-icon {
  height: 50px;
  width: 50px;
  border-radius: 3px;
  position: fixed;
  padding: 3px;
}

.page {
  width: 100%;
}

.page img {
  width: 100%;
}

.lifelayer-profile-icon img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.column-1::-webkit-scrollbar {
  display: none;
}

@media (max-width: 400px) {
  .page1,
  .page2,
  .page3 {
    width: 100%;
    height: 300px;
  }

  .page1 img,
  .page2 img,
  .page3 img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .lifelayer-sidebar-dropdown,
  .lifelayer-tooltip {
    width: 150px;
  }

  .lifelayer-tooltip-text {
    font-weight: 500;
  }
}

.grid-container {
  height: 100vh;
}

.column-2::-webkit-scrollbar {
  display: none !important;
}

.column {
  overflow-y: auto;
  max-height: 100vh;
}

.radio1 {
  position: fixed;
  height: 46px;
  width: 60px;
}

.radio1 img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  cursor: pointer;
  object-fit: cover;
}

.profile_picture_container {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: white;
}

.profile_picture_container .video1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dasboard_sidebar {
  color: black !important;
  text-decoration: none;
}

/* Mobile view */
@media (max-width: 768px) {
  .lifelayer-sidebar {
    top: 0;
    width: 60px;
    left: -100px;
    z-index: 9999;
    transition: all 0.5s;
    height: 1000px !important;
    background-color: white;
  }

  .lifelayer-sidebar.open {
    left: 0px;
    background-color: white;
  }

  .profile_picture_container {
    background-color: white;
  }

  .radio1 {
    height: 52px;
  }
}
</style>
